var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './SalesforceButton.scss';
import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import classNames from 'classnames';
import { SalesforceLogo } from '@ui/icons';
import { SonarText } from '@ui/text';
import { useAmplitude } from '@hooks';
import { Button, Popconfirm, Space } from 'antd';
import { CHANGE_EVENT_PREFERENCES, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
export const SalesforceButton = (_a) => {
    var { className, name, href, onClick } = _a, rest = __rest(_a, ["className", "name", "href", "onClick"]);
    const log = useAmplitude();
    const handleClick = useCallback(() => {
        log(AMPLITUDE_EVENT.PULSE_OBJECT_CHANGED);
        window.open(href);
        onClick();
    }, [href, log, onClick]);
    return (React.createElement(Popconfirm, { cancelText: COPY_SPECIFIC.NO, okText: COPY_SPECIFIC.YES, onConfirm: handleClick, overlayClassName: 'manage-objects-popover', placement: 'bottom', title: React.createElement(React.Fragment, null,
            React.createElement("p", null,
                React.createElement(SonarText, { className: 'manage-objects-confirm-message' }, CHANGE_EVENT_PREFERENCES.MANAGE_OBJECTS_CONFIRM_LINE1)),
            React.createElement("p", null,
                React.createElement(SonarText, { className: 'manage-objects-confirm-message' }, CHANGE_EVENT_PREFERENCES.MANAGE_OBJECTS_CONFIRM_LINE2))) },
        React.createElement(Button, Object.assign({ className: classNames('salesforce-button', className), disabled: href === '', type: 'link' }, rest),
            React.createElement(Space, { align: 'center', size: 'small' },
                React.createElement(SalesforceLogo, null),
                name))));
};
